/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Hook_DescriptionInputs */

const en_onboarding_v1_hook_description = /** @type {(inputs: Onboarding_V1_Hook_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join 200k+ people growing their money the calm way.`)
};

const de_onboarding_v1_hook_description = /** @type {(inputs: Onboarding_V1_Hook_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließe dich über 200.000 Menschen an, die ihr Geld ganz entspannt wachsen lassen.`)
};

const pt_br2_onboarding_v1_hook_description = /** @type {(inputs: Onboarding_V1_Hook_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Junte-se a mais de 200 mil pessoas que fazem o dinheiro crescer com tranquilidade.`)
};

const tr_onboarding_v1_hook_description = /** @type {(inputs: Onboarding_V1_Hook_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parasını zahmetsizce büyüten 200 binden fazla kişiye katılın.`)
};

const zh_cn2_onboarding_v1_hook_description = /** @type {(inputs: Onboarding_V1_Hook_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加入 20 万+ 用户，轻松稳健地让财富增长。`)
};

const zh_hk2_onboarding_v1_hook_description = /** @type {(inputs: Onboarding_V1_Hook_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加入 20 萬+ 用戶，輕鬆穩健地讓財富增長。`)
};

const ko_kr2_onboarding_v1_hook_description = /** @type {(inputs: Onboarding_V1_Hook_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`마음 편히 자산을 키우는 20만 명 이상의 사람들과 함께하세요.`)
};

const ru_ru2_onboarding_v1_hook_description = /** @type {(inputs: Onboarding_V1_Hook_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Присоединяйтесь к более чем 200 тысячам людей, которые спокойно приумножают свои деньги.`)
};

const es_419_onboarding_v1_hook_description = /** @type {(inputs: Onboarding_V1_Hook_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Únete a más de 200 mil personas que hacen crecer su dinero con tranquilidad.`)
};

/**
* | output |
* | --- |
* | "Join 200k+ people growing their money the calm way." |
*
* @param {Onboarding_V1_Hook_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_hook_description = /** @type {((inputs?: Onboarding_V1_Hook_DescriptionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Hook_DescriptionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_hook_description(inputs)
	if (locale === "de") return de_onboarding_v1_hook_description(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_hook_description(inputs)
	if (locale === "tr") return tr_onboarding_v1_hook_description(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_hook_description(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_hook_description(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_hook_description(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_hook_description(inputs)
	return es_419_onboarding_v1_hook_description(inputs)
});